<template>
  <vue-draggable-resizable
    :w="width"
    :h="height"
    :x="posX"
    :y="posY"
    @dragstop="onDragStop"
    :active="true"
    :parent="true"
    :resizable="false"
    :drag-handle="'.drag'"
    class="network-layers-container"
  >
    <div class="layersCable toolsWindow drag scroll-fire-fox">
      <v-layout
        row
        justify-space-between
        class="home-floating-window-header layersCableTitle"
      >
        {{ $t("NetworkLayers") }}
        <window-header-button
          @onClick="close"
          mode="dark"
          style="margin-left: 20px;"
        />
      </v-layout>

      <v-treeview
        :value="selected"
        :items="menu"
        @input="setActiveNetworkFilters"
        item-key="key"
        item-children="submenu"
        item-text="name"
        selectable
        style="text-align: left; font-size: 12px;"
        id="layers-network-tree"
        return-object
      >
        <template v-slot:prepend="{ item, active }">
          <component
            :is="item.icon"
            width="15px"
            style="margin-right: 3px; margin-top: 6px"
          />
        </template>

        <template v-slot:label="{ item }">
          <span style="font-size: 10px; padding-left: 3px">
            {{ item.name }}
          </span>
        </template>
      </v-treeview>
    </div>
  </vue-draggable-resizable>
</template>

<script>
import { mapActions } from "vuex";
import { listsMixin } from "@/mixins/listsMixin";

import CloseWindowSVG from "@/assets/sidebar/closeWindowArrow.svg";
import WindowHeaderButton from "@/components/_Atoms/WindowHeaderButton";
import ManholeSVG from "@/assets/tools_svgs/manhole.svg";
import CableSVG from "@/assets/designer_layers_svgs/cable.svg";
import PoleSVG from "@/assets/designer_layers_svgs/pole.svg";
import ClosureSVG from "@/assets/tools_svgs/closure.svg";

export default {
  name: "NetworkLayers",

  mixins: [listsMixin],

  components: {
    WindowHeaderButton,
    CloseWindowSVG,
    CableSVG,
    PoleSVG
  },

  data() {
    return {
      menu: [],
      selected: [],

      posY: 10,
      posX: 210,
      width: 210,
      height: 700
    };
  },

  computed: {
    showNetworkLayers() {
      return this.$store.getters.isShowTabNetworkLayers;
    }
  },

  watch: {
    showNetworkLayers() {
      if (!this.showNetworkLayers) {
        this.selected = [];
        this.selectAll();
      }
    }
  },

  mounted() {
    this.generateMenu();
  },

  methods: {
    ...mapActions([
      "setShowTabNetworkLayers",
      "setActiveNetworkFilters",
      "GET_LIST"
    ]),

    close() {
      this.setShowTabNetworkLayers(false);
      this.setActiveNetworkFilters([]);
    },

    selectAll() {
      if (this.menu) {
        for (let i = 0; i < this.menu.length; i++) {
          this.selected.push(this.menu[i]);
        }
      }
    },

    onDragStop(x, y) {
      this.posX = x;
      this.posY = y;
    },

    async generateMenu() {
      let menu = [
        {
          name: this.$i18n.tc("Cable", 1),
          key: "cable",
          icon: CableSVG,
          submenu: [
            {
              name: this.$i18n.t("Backbone"),
              key: "cableBackbone",
              filters: [{ field: "cb_logical_type", value: 4 }]
            },
            {
              name: this.$i18n.t("Feeder"),
              key: "cableFeeder",
              filters: [{ field: "cb_logical_type", value: 3 }]
            },
            {
              name: this.$i18n.t("Distribution"),
              key: "cableDistribution",
              filters: [{ field: "cb_logical_type", value: 2 }]
            },
            {
              name: this.$i18n.t("Drop"),
              key: "cableDrop",
              filters: [{ field: "cb_logical_type", value: 1 }]
            }
          ]
        },
        {
          name: this.$i18n.tc("Pole", 1),
          key: "pole",
          icon: PoleSVG,
          submenu: []
        },
        {
          name: this.$i18n.tc("Closure", 1),
          key: "closure",
          icon: ClosureSVG,
          submenu: []
        },
        {
          name: this.$i18n.tc("Chambers", 1),
          key: "Chambers",
          icon: ManholeSVG,
          submenu: []
        }
      ];

      try {
        let organizationList = await this.getOrganizationList();
        if (organizationList) {
          menu[1].submenu = this.getLayerOptions(organizationList, "tp_owner");
          menu[2].submenu = this.getLayerOptions(organizationList, "cl_owner");
          menu[3].submenu = this.getLayerOptions(organizationList, "man_owner");
        }
      } finally {
        this.menu = menu;
        this.selectAll();
      }
    },

    getLayerOptions(list, field) {
      let prepareOption = [];
      list.forEach(item => {
        let name = this.getListElementLabel(item);
        prepareOption.push({
          name: name,
          key: name + field,
          filters: [{ field: field, value: item.code }]
        });
      });
      return prepareOption;
    },

    async getOrganizationList() {
      try {
        return await this.GET_LIST({ listName: "list_organization" });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.network-layers-container{
  z-index: 999 !important;
}
.layersCable {
  position: absolute;
  width: fit-content;
  z-index: 100;
  background-color: white;
  overflow: auto;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
  border-left: none;
  border-radius: 4px;
  padding: 2px 15px 10px 20px;
}

.layersCableTitle {
  line-height: 20px;
  font-size: 12px;
  position: relative;
  font-weight: bold;
  margin-top: 20px;
  color: var(--font-color);
  text-align: left;
  margin-bottom: 10px;
  width: 140px;
}
</style>

<style>
#layers-network-tree .v-treeview-node--leaf {
  display: flex;
  margin-left: 26px !important;
}

#layers-network-tree .v-treeview-node__root {
  min-height: 20px !important;
  padding-left: 0 !important;
}

#layers-network-tree .v-icon {
  font-size: 16px;
  margin: 0 !important;
}

#layers-network-tree .v-treeview-node__level {
  width: 10px !important;
}
#layers-network-tree .v-treeview-node__content,
#layers-network-tree .v-treeview-node__prepend,
#layers-network-tree .v-treeview-node__label {
  margin: 0 !important;
  min-width: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/SideBar/SidebarWindows/Layers/NetworkLayers.vue